<div class="dashboard-header d-flex justify-content-between align-items-center p-3">
    <div class="d-flex align-items-center">
        <div class="avatar me-3">
            <img src="assets/images/logo03.svg" alt="BeExpert logo" />
        </div>
        <div>
            <h4 class="mb-0">BeExpert</h4>
        </div>
    </div>

    <div class="d-flex align-items-center">
        <div class="text-end me-3">
            <div class="fw-bold">Super Admin User</div>
            <small>Administrator</small>
        </div>

        <div class="user-dropdown">
            <div class="user-toggle d-flex align-items-center" (click)="toggleDropdown()">
                <div class="user">AD</div>
                <i class="bi bi-caret-down ms-2"></i>
            </div>

            <div class="dropdown-menu" [class.show]="isDropdownOpen" (click)="logout()">
                <a class="dropdown-item logout"><i class="bi bi-box-arrow-right me-2"></i> Logout</a>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="isLoading;else pageContent">
<div class="app-spinner">
	<mat-spinner></mat-spinner>
</div>
</ng-container>

<ng-template #pageContent>
<div class="container-fluid dashboard-wrapper py-4">
    <div class="row g-4">
        <div class="col-12 col-sm-6 col-lg-4" *ngFor="let adminInfo of _adminCard">
            <div class="stat-card">
                <div class="d-flex justify-content-between align-items-start">
                    <div class="icon-wrap"><i [class]="adminInfo.icon"></i></div>
<i [ngClass]="[adminInfo.icon, adminInfo.cssClass]"></i>
                </div>
                <h6 class="stat-title">{{adminInfo.adminTitle}}</h6>
                <h2 class="stat-value">{{adminInfo.adminCount}}</h2>
            </div>
        </div>

    </div>
</div>
</ng-template>